import { EmailRequest } from "@/model/models";
import { formatUnixTimestampDate } from "@/utils/general-functions"
class FunctionService {
    public downloadEmailsAsCSV(emailList: string[], emailRequest: EmailRequest) {
        if (!emailList || emailList.length === 0) {
            throw new Error('No emails to download.');
        }

        try {
            // Convert email list to CSV format (one email per line)
            const csvContent = emailList.join('\n');

            // Create a Blob with the CSV content
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

            // Create a URL for the Blob
            const url = URL.createObjectURL(blob);

            // Define the filename based on the emailRequest typeUser
            const filename = emailRequest.typeUser === 'TRIAL'
                ? `emails_${emailRequest.typeUser}_${emailRequest.monthsAgo}_months_ago_${formatUnixTimestampDate(emailRequest.startDate)}_${formatUnixTimestampDate(emailRequest.endDate)}.csv`
                : `emails_${emailRequest.typeUser}_${formatUnixTimestampDate(emailRequest.startDate)}_${formatUnixTimestampDate(emailRequest.endDate)}.csv`;

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); // Set the dynamic file name
            document.body.appendChild(link);

            // Trigger the download
            link.click();

            // Clean up
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (e) {
            throw new Error('Failed to download emails as CSV.');
        }
    }
}

export default new FunctionService();
